import * as React from 'react';

import * as style from './NotificationStyle.module.scss'

type Props = {
  children: React.ReactNode;
};

export const Notification = ({ children }: Props) => (
  <p className={style.notification}>{children}</p>
);
